import { createFileRoute, Outlet } from '@tanstack/react-router'
import PlanViewerNew from '../../../../../../containers/plan-viewer'
import { pinsSearchSchema } from '../search-schemas'

// Layout boundary for the `/pins/:viewType/**` viewer family (Card 3.9 / 3.10).
// Mounts <PlanViewerNew /> once and lets the leaf routes drive path identity
// (planId / pinId) via useParams({ strict: false }). The shared 3.8 schema is
// applied here so every leaf inherits the validated search state.
export const Route = createFileRoute(
  '/_authenticated/project/$projectId/pins/$viewType'
)({
  validateSearch: pinsSearchSchema,
  component: PinsViewerLayout
})

function PinsViewerLayout() {
  return (
    <>
      <PlanViewerNew />
      <Outlet />
    </>
  )
}
